














import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class AccountCommonHeader extends Vue {
  /**
   * @description 返回
   */
  private goBack() {
    const backSource: any = localStorage.getItem("beforeAccountSource");
    if (backSource) {
      this.$router.push(JSON.parse(backSource));
    } else {
      this.$router.push("/main/home");
    }
  }
}
